import { User, UserRequestUpdate } from '@/types/userList';
import { api } from '@/services/api/axios/instance';

export const userListApi = {
  getUsers: async (organizationId: number) => {
    const path = `/organizations/${organizationId}/users`;
    return api.get(path, {});
  },
  getUsersCSV: async (organizationId: number) => {
    const path = `/organizations/${organizationId}/users/csv`;
    return api.get(path, {});
  },
  updateUser: async (
    organizationId: number,
    userId: number,
    user: UserRequestUpdate,
  ) => {
    const path = `/organizations/${organizationId}/users/${userId}`;
    await api.patch(path, user);
  },
  updateUsers: async (organizationId: number, users: User[]) => {
    const path = `/organizations/${organizationId}/users/bulk_update`;
    await api.post(path, { users });
  },
};
